let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5YEPv")).then(() => parcelRequire('3Z1ar'));